(function () {

    var colorSelecorType;
    if ($('#colorOptionSelect').length) {
        colorSelecorType = 'select';
    } else if($('#colorOptionRadio').length) {
        colorSelecorType = 'radio';
    }
    
    $('.product-swatch--button').not('.product-swatch--custom').on('click',function() {
        $('.product-swatch--button').removeClass('swatch-active');
        $(this).addClass('swatch-active');
        currentColor = $(this).data('swatch-value');
        $('#currentColor').html(currentColor);
        if (colorSelecorType == 'select') {
            $('#colorOptionSelect select').val(currentColor);
            document.querySelector('variant-selects').dispatchEvent(new Event('change', { bubbles: true }));
        } else {
            $('#colorOptionRadio [value="' + currentColor + '"]').click();
        }
    });

})()
